import { Colors } from './Colors'

export const TextContents = {
    popup: {
        text: "Dans cette dernière étape, replacez les six actions permettant d'augmenter son FR et d'optimiser son BFR.",
    },
    consigne: {
        text: "Replacez les six actions permettant d'augmenter son FR et d'optimiser son BFR.",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 381 }
    },
    title : {
        text : "TRÉSORERIE NETTE, FONDS DE ROULEMENT ET BESOIN EN FONDS DE ROULEMENT",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique24\'>ÉTAPE 4 :</class> Augmenter son FR et optimiser son BFR",
        config: { size: '24px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    bravo : {
        text: "Vous avez replacé correctement les 6 actions permettant d'augmenter son FR et d'optimiser son BFR."
    }
}

export const CartesInfos = [
    {
        titre: "Négocier les délais de paiement",
        image: "negocier_delais",
        angle: 1,
        zoneType: "BFR",
        zoneId: 6,
        cardY: -202
    },
    {
        titre: "Souscrire de nouveaux emprunts",
        image: "souscrire_emprunts",
        angle: -1,
        zoneType: "FR",
        zoneId: 3,
        cardY: -130
    },
    {
        titre: "Limite les stocks",
        image: "limiter_stocks",
        angle: 1,
        zoneType: "BFR",
        zoneId: 4,
        cardY: -60
    },
    {
        titre: "Augmenter et ouvrir le capital",
        image: "augmenter_capital",
        angle: 1,
        zoneType: "FR",
        zoneId: 2,
        cardY: 10
    },
    {
        titre: "Réduire les délais de règlement",
        image: "reduire_delais",
        angle: -1,
        zoneType: "BFR",
        zoneId: 5,
        cardY: 80
    },
    {
        titre: "Maintenir les bénéfices réalisés dans l'entreprise",
        image: "maintenir_benefices",
        angle: -1,
        zoneType: "FR",
        zoneId: 1,
        cardY: 150
    },
]
export const ZonesInfos = [
    {
        zoneX: 230,
        zoneY: 325,
        zoneType: "FR",
        zoneId: 1,
    },
    {
        zoneX: 230,
        zoneY: 540,
        zoneType: "FR",
        zoneId: 2,
    },
    {
        zoneX: 230,
        zoneY: 790,
        zoneType: "FR",
        zoneId: 3,
    },
    {
        zoneX: 1212,
        zoneY: 325,
        zoneType: "BFR",
        zoneId: 4,
    },
    {
        zoneX: 1212,
        zoneY: 546,
        zoneType: "BFR",
        zoneId: 5,
    },
    {
        zoneX: 1212,
        zoneY: 770,
        zoneType: "BFR",
        zoneId: 6,
    },
]